import React from "react";
import PropTypes from "prop-types";
import aiCreditImg from "./../../assets/images/AI_data_table.png";
import { buttonName, UserManagment } from "../../locales/en";
import Modalstyle from "./modal.module.scss";
import CommonModal from "./CommonModal";

const AiCreditReportModal = ({ toggle, isOpen, creditScoreData }) => {
  const modalTitle =
    UserManagment?.financialsTab?.aiCreditScoreSection?.aiCreditModal?.title;

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={modalTitle}
      modalClassName="modal-lg"
      bodyClassName={Modalstyle.modalBody}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: toggle
        }
      ]}
    >
      <div className="row">
        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <img
              src={aiCreditImg}
              alt="aiCreditImg"
              width="1167"
              height="255"
            />
          </div>
        </div>
        {creditScoreData?.overdueOutput && (
          <div className="mb-2">
            <div className={Modalstyle.modalInputwrap}>
              <p>
                <strong>
                  {
                    UserManagment?.financialsTab?.aiCreditScoreSection
                      ?.aiCreditModal?.invoiceLabel
                  }
                  {creditScoreData?.overdueOutput}
                </strong>
              </p>
            </div>
          </div>
        )}
        {creditScoreData?.imageURL && (
          <div className="mb-3">
            <div className={Modalstyle.modalInputwrap}>
              <img src={creditScoreData?.imageURL} alt="ai data" />
            </div>
          </div>
        )}
      </div>
    </CommonModal>
  );
};
AiCreditReportModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  creditScoreData: PropTypes.any
};

export default AiCreditReportModal;
